import { PathBase } from "@constellation-academy/epic-ui";

export class OfferSubscriptionsPath extends PathBase {
	static readonly pathKey = "offerSubscriptions";
	static readonly pathName = "offer-subscriptions";
}
